import request from '@/utils/request'

const upload = (fmData, path) => {
  return request({
    url: `${process.env.VUE_APP_FILE_API}/Minio/Upload`,
    method: 'post',
    params: { path },
    data: fmData
  })
}

const copyFile = (oldFileName, newFileName) => {
  return request({
    url: `${process.env.VUE_APP_FILE_API}/Minio/CopyFile`,
    method: 'post',
    data: { oldFileName, newFileName }
  })
}

export default {
  upload,
  copyFile
}
